import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: 'How to create an account?',
      answer: 'To create an account, click the "Register" button in the top right corner and fill in the required fields.',
    },
    {
      question: 'How to reset my password?',
      answer: 'Go to the login page and click on "Forgot Password?". Follow the instructions to reset your password.',
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept Visa and MasterCard, as well as payments through PayPal and bank transfers.',
    },
    {
      question: 'How to contact support?',
      answer: 'You can reach our support team via the contact form on our website or by calling +1 (234) 567-89-01.',
    },
    // Add more questions and answers as needed
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Inline styles for the component
  const styles = {
    container: {
      maxWidth: '600px',
      margin: '150px auto',
    
      padding: '0 20px',
    },
    faqItem: {
      borderBottom: '1px solid #ddd',
      padding: '15px 0',
      cursor: 'pointer',
      transition: 'background-color 0.3s',
    },
    faqItemActive: {
      backgroundColor: '#f9f9f9',
    },
    question: {
      fontSize: '18px',
      fontWeight: '600',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    answer: {
      marginTop: '10px',
      fontSize: '16px',
      lineHeight: '1.5',
      color: '#555',
      animation: 'fadeIn 0.3s ease-in-out',
    },
    icon: {
      transition: 'transform 0.3s',
      fontSize: '24px',
      lineHeight: '1',
    },
    iconOpen: {
      transform: 'rotate(45deg)',
    },
  };

  return (
    <div style={styles.container}>
      <h2>Frequently Asked Questions</h2>
      {faqs.map((faq, index) => (
        <div
          key={index}
          style={{
            ...styles.faqItem,
            ...(activeIndex === index ? styles.faqItemActive : {}),
          }}
          onClick={() => toggleFAQ(index)}
        >
          <div style={styles.question}>
            {faq.question}
            <span
              style={{
                ...styles.icon,
                ...(activeIndex === index ? styles.iconOpen : {}),
              }}
            >
              +
            </span>
          </div>
          {activeIndex === index && (
            <div style={styles.answer}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQ;
